interface LatestItem {
    title: string;
    permalink: string;
    location: string;
    dateLabel: string;
    edited: boolean;
    originalDateLabel: string;
}

interface LatestPayload {
    latest: Record<string, LatestItem[]>;
}

const DISPLAY_COUNT = 8;

class SidebarLatest {
    private _card: HTMLElement;
    private _list: HTMLElement;
    private _locale: string;
    private _currentPermalink: string;

    init() {
        this._card = document.querySelector("#sidebar-latest");
        if (!this._card) {
            return;
        }

        this._list = this._card.querySelector("#sidebar-latest-list");
        this._locale = this._card.dataset.locale || "";
        this._currentPermalink = this._card.dataset.currentPermalink || "";

        if (!this._list || !this._locale) {
            return;
        }

        fetch("/index.json")
            .then((response) => response.json())
            .then((payload: LatestPayload) => this.render(payload))
            .catch(() => {
                // Fetch/parse failure: drop the shell rather than leave an
                // empty "Latest" header with nothing under it.
                this._card.remove();
            });
    }

    private render(payload: LatestPayload) {
        const items = (payload?.latest?.[this._locale] || [])
            .filter((item) => item.permalink !== this._currentPermalink)
            .slice(0, DISPLAY_COUNT);

        if (!items.length) {
            this._card.remove();
            return;
        }

        this._list.innerHTML = "";
        items.forEach((item) => this._list.appendChild(this.buildItem(item)));
    }

    private buildItem(item: LatestItem): HTMLAnchorElement {
        const a = document.createElement("a");
        a.className = "mini-post";
        a.href = item.permalink;

        const title = document.createElement("div");
        title.className = "t";
        title.textContent = item.title;

        const row = document.createElement("div");
        row.className = "row";

        const meta = document.createElement("div");
        meta.className = "m";
        meta.textContent = item.location ? `${item.location} · ${item.dateLabel}` : item.dateLabel;

        row.appendChild(meta);

        if (item.edited) {
            const icon = document.createElement("i");
            icon.className = "fas fa-pen edit-icon";
            icon.title = `Originally posted ${item.originalDateLabel}`;
            icon.setAttribute("aria-hidden", "true");
            row.appendChild(icon);

            const label = document.createElement("span");
            label.className = "visually-hidden";
            label.textContent = ` (updated; originally posted ${item.originalDateLabel})`;
            row.appendChild(label);
        }

        a.appendChild(title);
        a.appendChild(row);
        return a;
    }
}

export default new SidebarLatest();
